import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { OrganizationMember } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';
import { refreshMembersOnConflict } from './refresh-members-on-conflict';

export type UnsuspendOrganizationMemberParams = {
  organizationId: string;
  memberId: string;
};

export const unsuspendOrganizationMember = async (
  params: UnsuspendOrganizationMemberParams,
): Promise<OrganizationMember> => {
  return await tinctApi.organizationMembers.unsuspendMember(
    params.organizationId,
    params.memberId,
  );
};

export const useUnsuspendOrganizationMember = (
  options?: Omit<
    UseMutationOptions<OrganizationMember, ApiError, UnsuspendOrganizationMemberParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, onError, ...restOptions } = options || {};

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: unsuspendOrganizationMember,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: ['organization-members', args[1].organizationId],
      });
      queryClient.invalidateQueries({
        queryKey: ['organization-member', args[1].organizationId, args[1].memberId],
      });
      onSuccess?.(...args);
    },
    onError: (...args) => {
      refreshMembersOnConflict(queryClient, args[0], args[1].organizationId);
      onError?.(...args);
    },
    ...restOptions,
  });
};
